import * as t from 'io-ts';
import {
  StatusMessageResponse,
  StatusMessageResponseV,
} from '../../../server/lib/metro/types';
import { decode } from '../../../server/lib/codec';
import { getAppointmentTimesDtoV, getScheduledAppointmentDtoV } from './types';

export const getAppointmentTimes = async (
  carrier: string,
  trackingNumber: string,
  retailerMoniker: string,
  trackingStatusCode: string,
): Promise<
  | t.TypeOf<typeof getAppointmentTimesDtoV>
  | t.TypeOf<typeof StatusMessageResponseV>
> => {
  const params = new URLSearchParams({
    retailerMoniker,
    trackingStatusCode,
  }).toString();
  const endpoint = `/api/v1/delivery-management/carriers/${carrier}/tracking-numbers/${trackingNumber}/scheduled-delivery/slots?${params}`;
  const response = await fetch(endpoint);

  if (response.status >= 500) {
    throw new Error('An unrecoverable error occurred calling the backend API.');
  }

  const json = (await response.json()) as unknown;

  if (json && typeof json === 'object' && 'status' in json) {
    return decode(StatusMessageResponseV, json);
  }

  return decode(getAppointmentTimesDtoV, json);
};

export const scheduleAppointment = async (
  carrier: string,
  trackingNumber: string,
  retailerMoniker: string,
  date: string,
  time?: string,
  formattedDate?: string,
): Promise<StatusMessageResponse> => {
  const endpoint = `/api/v1/delivery-management/carriers/${carrier}/scheduled-delivery/appointments?retailerMoniker=${retailerMoniker}`;

  const body: {
    date: string;
    trackingNumber: string;
    time?: string;
    formattedDate?: string;
  } = {
    date,
    trackingNumber,
    time,
    formattedDate,
  };

  const init: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  const response = await fetch(endpoint, init);

  if (response.status >= 500) {
    throw new Error('An unrecoverable error occurred calling the backend API.');
  }

  const json = (await response.json()) as unknown;
  return decode(StatusMessageResponseV, json);
};

export const rescheduleAppointment = async (
  carrier: string,
  trackingNumber: string,
  retailerMoniker: string,
  date: string,
  time: string,
): Promise<StatusMessageResponse> => {
  const endpoint = `/api/v1/delivery-management/carriers/${carrier}/scheduled-delivery/appointments/${trackingNumber}?retailerMoniker=${retailerMoniker}`;

  const body: { date: string; time: string } = {
    date,
    time,
  };

  const init: RequestInit = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };

  const response = await fetch(endpoint, init);

  if (response.status >= 500) {
    throw new Error('An unrecoverable error occurred calling the backend API.');
  }

  const json = (await response.json()) as unknown;

  return decode(StatusMessageResponseV, json);
};

export const getScheduledAppointment = async (
  carrier: string,
  trackingNumber: string,
  retailerMoniker: string,
): Promise<t.TypeOf<typeof getScheduledAppointmentDtoV>> => {
  const endpoint = `/api/v1/delivery-management/carriers/${carrier}/scheduled-delivery/appointments/${trackingNumber}?retailerMoniker=${retailerMoniker}`;

  const response = await fetch(endpoint);

  if (response.status >= 500) {
    throw new Error('An unrecoverable error occurred calling the backend API.');
  }

  const json = (await response.json()) as unknown;

  return decode(getScheduledAppointmentDtoV, json);
};
